import * as React from "react";
import { Button } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { cloneDeep, get } from "lodash";
import { NameValuePair } from "../../../schema/types/base";
import { store } from "../../../store";
import { formSet, formSetValue, formTriggerValidation } from "../../gvc/testNewForm/utils";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { ListDragHandle } from "./dragHandle";
import { RuleHeaders } from "./ruleHeaders";
import { CpCheckbox } from "../../gvc/testNewForm/CpCheckbox";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props {
  name?: string;
  item?: NameValuePair;
  index?: number;
}
export const CpArrayItemSidecarJwtPathBasedAuthControl: React.FC<Props> = React.memo(
  ({ name: _name, item: _item, index: _index }) => {
    const { id } = useCpFormContext();

    const name = _name!;
    const item = _item!;
    const index = _index!;

    function remove() {
      const form = store.getState().form.instances[id];
      const values = form.values;
      const items = get(values, name) || [];
      let _items = cloneDeep(items);
      _items = _items.filter((i) => i.id !== item.id);
      formSetValue(id, name, _items);

      formTriggerValidation(id);
    }

    return (
      <div key={item.id} className="mb-6 pb-6 border-b relative">
        <ListDragHandle />
        <div className="flex-grow flex items-center gap-8">
          <CpInput
            name={`sidecar.envoy.jwt.rules.${index}.prefix`} // header key
            className={"flex-grow"}
            placeholder="Path"
          />
          <div className="flex items-center gap-2">
            <div style={{ minWidth: 100 }}>
              <CpLabel name={`sidecar.envoy.jwt.rules.${index}.excludeAuth`}>Exclude Auth</CpLabel>
            </div>
            <CpCheckbox name={`sidecar.envoy.jwt.rules.${index}.excludeAuth`} />
          </div>
          <Button htmlType={`button`} type={"text"} danger icon={<MinusCircleOutlined />} onClick={() => remove()} />
        </div>
        <RuleHeaders index={index} />
      </div>
    );
  },
);
